// extracted by mini-css-extract-plugin
export default {"productCarousel":"GZ-z"};